"use client";
import { createContext } from "react";
import {
    PERSONA_VERIFICATION_STATUS,
    type PersonaVerificationStatus,
} from "./constants";

/* eslint-disable indent -- the rule misreads Prettier-aligned generic call delimiters */
export const PersonaContext = createContext<{
    verifyId: () => void;
    verificationStatus: PersonaVerificationStatus;
    isVerificationInProgress: boolean;
}>({
    verifyId: () => {},
    verificationStatus: PERSONA_VERIFICATION_STATUS.IDLE,
    isVerificationInProgress: false,
});
/* eslint-enable indent */

